<template>
  <b-modal
    ref="markPlanPaidModal"
    hide-footer
    title="Mark Installment as Paid"
    centered
    lazy
    @hide="hideModal"
    size="md"
  >
    <b-form class="col-md-12 px-0 pt-0" @submit.prevent="onSubmit">
      <b-form-group label="Amount" label-class="form-label">
        <b-form-input :value="$n(planAmount, 'currency', 'en-US')" disabled />
      </b-form-group>

      <b-form-group label="Payment Date" label-for="date-paid" label-class="form-label">
        <b-form-input id="date-paid" type="date" required v-model="datePaid" :max="today" />
      </b-form-group>

      <b-form-group label="Description" label-for="description" label-class="form-label">
        <b-form-textarea
          id="description"
          placeholder="Enter a note for this payment (e.g. paid in cash, check #123)"
          :rows="4"
          v-model="description"
        />
      </b-form-group>

      <div class="d-flex justify-content-end">
        <b-button variant="light" class="mr-2" @click.prevent="hideModalManual">Cancel</b-button>
        <b-btn variant="primary" :disabled="isLoading" style="width: 150px" type="submit" class="btn-normal">
          <i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i>
          <span v-else>Mark as Paid</span>
        </b-btn>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: 'MarkPlanPaidModal',

  props: {
    showModal: { type: Boolean, default: false },
    plan: { type: Object, default: null },
  },

  data() {
    return {
      description: '',
      datePaid: '',
      isLoading: false,
    };
  },

  computed: {
    planAmount() {
      return (this.plan && this.plan.amount) || 0;
    },
    today() {
      return new Date().toISOString().slice(0, 10);
    },
  },

  methods: {
    resetData() {
      this.description = '';
      this.datePaid = '';
      this.isLoading = false;
    },

    onSubmit() {
      this.isLoading = true;
      // date_paid is sent as 'YYYY-MM-DD HH:MM' to match the backend format.
      const datePaid = this.datePaid ? `${this.datePaid} 00:00` : '';
      this.$emit('confirm', {
        plan: this.plan,
        description: this.description,
        date_paid: datePaid,
      });
    },

    hideModal() {
      this.$emit('close');
      this.resetData();
    },

    hideModalManual() {
      this.$refs.markPlanPaidModal.hide();
      this.hideModal();
    },
  },

  watch: {
    showModal(value) {
      if (value) {
        this.datePaid = this.today;
        this.$refs.markPlanPaidModal.show();
      } else if (this.$refs.markPlanPaidModal) {
        this.$refs.markPlanPaidModal.hide();
      }
    },
  },
};
</script>

<style></style>
